import { FC, memo, useCallback, useMemo } from 'react'
import { Divider } from '@cargomart/ui'
import { useNavigate } from '@tanstack/react-router'
import { ModalSimple } from 'components/ModalSimple'
import { Tab, TabList, TabProvider } from 'components/Tab'
import { OrderCargoServiceType } from 'schema'

import { OrderServiceTypeInfoContent } from './OrderServiceTypeInfoContent'

type OrderServiceTypeInfoProps = {
  handleClose: () => void
  id: string
}

const OrderServiceTypeInfo: FC<OrderServiceTypeInfoProps> = (props) => {
  const { handleClose: handleCloseModal, id } = props
  const navigate = useNavigate()

  const handleClose = useCallback(() => {
    handleCloseModal()
    navigate({ hash: undefined })
  }, [handleCloseModal, navigate])

  const additional = useMemo(
    () => (
      <>
        <TabList className="!ml-2 mt-4 md:!ml-0 md:mt-0">
          <Tab tabId={OrderCargoServiceType.Id.CUSTOM}>Тариф &laquo;Гибкий&raquo;</Tab>
          <Tab tabId={OrderCargoServiceType.Id.PALLET}>Тариф &laquo;Палета&raquo;</Tab>
        </TabList>
        <Divider className="block md:hidden" />
      </>
    ),
    []
  )

  return (
    <TabProvider defaultTab={OrderCargoServiceType.Id.CUSTOM}>
      <ModalSimple
        headerAdditional={additional}
        id={id}
        isCentered={false}
        mobileHeaderAdditional={additional}
        onClose={handleClose}
        title="Ограничения для отправки посылки"
      >
        <OrderServiceTypeInfoContent className="mb-6" />
      </ModalSimple>
    </TabProvider>
  )
}

export default memo(OrderServiceTypeInfo)
